import styled from "styled-components";
const paddingTopLookup = {
    "16:9": "56.25%",
    "3:2": "66.66%",
    "4:3": "75%",
    "1:1": "100%",
    "3:4": "133.33%",
    "2:3": "150%",
};
function calculatePaddingTop(ratio) {
    if (ratio in paddingTopLookup) {
        return paddingTopLookup[ratio];
    }
    const [w, h] = ratio.split(":").map((x) => parseFloat(x));
    return `${(h / w) * 100}%`;
}
export const AspectRatio = styled.div `
  display: block;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "none"};

  &::before {
    content: "";
    display: block;
    padding-top: ${({ ratio }) => calculatePaddingTop(ratio)};
  }
  & > * {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: cover;
  }
`;
AspectRatio.displayName = "AspectRatio";
